"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _context = require("../context");

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */
var useCCXIngest = function useCCXIngest(project) {
  var ctx = (0, _react.useContext)(_context.IngestContext);
  return ctx[project] || ctx;
};

var _default = useCCXIngest;
exports["default"] = _default;